import { DateTime } from "luxon";
import z from "zod";

export function isDateWithinTextingHours(
  dateToCheck: Date,
  textingHours: { start: string; end: string; timezone: string }
): boolean {
  const dt = DateTime.fromJSDate(dateToCheck).setZone(textingHours.timezone);
  const startTime = timeOfDayOnDate(dt, textingHours.start);
  const endTime = timeOfDayOnDate(dt, textingHours.end);
  return dt >= startTime && dt <= endTime;
}

function timeOfDayOnDate(date: DateTime, timeStr: string): DateTime {
  const [hour = 0, minute = 0, second = 0] = timeStr.split(":").map(Number);
  return date.set({ hour, minute, second, millisecond: 0 });
}

export const E164PhoneNumberSchema = z
  .string()
  .regex(/^\+1\d{10}$/, "Must be a valid E.164-formatted phone number");

export const ShortCodeOrE164PhoneNumberSchema = z
  .string()
  .regex(
    /^(\d{5,6}|\+1\d{10})$/,
    "Must be a valid 5-digit or 6-digit short code or an E.164-formatted US phone number"
  );

export type OverrideFields<
  OriginalFields extends object,
  OverriddenFields extends object,
> = Omit<OriginalFields, keyof OverriddenFields> & OverriddenFields;

export const overrideZodInfer =
  <ZodInferredType extends object>(schema: z.ZodType<ZodInferredType>) =>
  <OverriddenFields extends object>(): z.ZodType<
    OverrideFields<ZodInferredType, OverriddenFields>
  > =>
    schema as unknown as z.ZodType<
      OverrideFields<ZodInferredType, OverriddenFields>
    >;
